
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';
import Gallerypage from './components/pages/Gallerypage';
import PrincipalSpeech from './components/pages/PrincipalSpeech';
import Iti from './components/pages/Iti';
import HotelManagement from './components/pages/HotelManagement';
import About from './components/pages/About';
import Paramedical from './components/pages/Paramedical';

function App() {
  return (
   <Router>
    
  <div>

   
    
    <Routes>

    <Route axact path="/" element={<Home/>}/>
    <Route axact path="/contact-us" element={<Contactus/>}/>
    <Route axact path="/gallery" element={<Gallerypage/>}/>
    <Route axact path="/principal-massage" element={<PrincipalSpeech/>}/>
    <Route axact path="/iti" element={<Iti/>}/>
    <Route axact path="/hotel-management" element={<HotelManagement/>}/>
    <Route axact path="/Paramedical" element={<Paramedical/>}/>
    <Route axact path="/aboutus" element={<About/>}/>
    </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
